<template>
  <ModalCard @close="$emit('modalToggle', '')">
    <template #title>
      {{ lang.modalTitle + " " + $coins[relatedCoin].code }}
    </template>
    <template #body>
      <div v-if="!selected_net" class="crypto-network">
        <div class="modal-text">{{ lang.chooseNetText }}</div>
        <div class="toggle-comp">
          <DropDown
            v-if="netsList"
            class="base-coin"
            @choose="
              (net) => {
                cryptoNetworkIndex = netsList.indexOf(
                  netsList.find((item) => item.value == net)
                );
              }
            "
            :items="netsList"
          />
        </div>
        <button class="modal-submit-btn" @click="selectNet()">
          {{ lang.confirmBtn }}
        </button>
      </div>
      <template v-else>
        <div class="modal-text">
          {{ lang.topText }}
        </div>
        <div class="qr-code">
          <img class="qr-img" :src="'data:image/png;base64,' + qrCode" alt="" />
        </div>
        <div class="address">
          <LabelInput
            :value="address"
            :label="$coins[relatedCoin].code + ' ' + lang.walletLabel"
            :disabled="true"
          />
          <img
            class="icon-copy"
            src="../../assets/icons/copy.svg"
            @click="copyAddress()"
          />
        </div>

        <div class="warning">
          <div>
            {{
              lang.depsoitWarnTextP1 +
              " " +
              $coins[relatedCoin].code +
              " " +
              lang.depsoitWarnTextP2
            }}
          </div>
        </div>

        <button
          class="modal-submit-btn"
          @click.prevent="checkWallet"
          :disabled="(txIdIsNeeded && !txid && !enable) || selected_net == ''"
        >
          {{ lang.checkDepsoitBtn }}
        </button>
      </template>
    </template>
  </ModalCard>
</template>

<script>
import DropDown from "../Tools/DropDown";
import ModalCard from "./ModalCard";
export default {
  name: "CryptoDepsoit",
  components: {
    ModalCard,
    DropDown,
  },
  props: ["relatedCoin", "isExchange"],
  data() {
    return {
      lang: this.$languageDict().wallets.modals.coinDepsoit,
      amount: "",
      address: "",
      qrCode: "",
      tag: "",
      txid: "",
      token: false,
      alertLink: false,
      drop: false,
      selected_net: "",
      txIdIsNeeded: false,
      enable: false,
      coins: [],
      cryptoNetworkIndex: 0,
      nets: [],
    };
  },
  computed: {
    netsList() {
      return this.nets.map((net) => {
        return {
          label: net.tokenType,
          value: net.tokenType,
        };
      });
    },
  },
  methods: {
    copyAddress() {
      navigator.clipboard.writeText(this.address);
      this.alertLink = true;
      setTimeout(() => {
        this.alertLink = false;
      }, 1500);
    },
    closeModale() {
      this.$emit("closeModaleEmit", this.close);
    },
    changeNetwork(e) {
      this.token = e;
      this.getQR();
    },

    async checkWallet() {
      this.state.loading = true;
      // const token = this.token ? 'ERC20' : 'TRC20'
      let query = {
        relatedCoin: this.relatedCoin,
        tokenType: this.selected_net,
        cryptoNetwork: this.selected_net,
        // walletType: (this.isExchange ? 'EXCHANGE' : 'P2P')
      };
      if (this.txIdIsNeeded) {
        query.txid = this.txid;
      }
      const res = await this.$axios.get(
        "/wallets/check-confirmed-transaction",
        {
          params: query,
        }
      );
      let text;
      if (res.baseDTO.amount) {
        if (this.$isPersian()) {
          text = `مقدار ${this.$toLocal(res.baseDTO.amount) || 0} ${
            this.$coins[this.relatedCoin].persianName
          } واریز شده و تایید ${
            res.baseDTO.transactionIsDone ? "شده" : "نشده"
          }`;
        } else {
          text = `The amount of ${this.$toLocal(res.baseDTO.amount) || 0} ${
            this.$coins[this.relatedCoin].englishName
          } has been deposited and ${
            res.baseDTO.transactionIsDone ? "confirmed" : "not confirmed"
          }`;
        }
      } else {
        text = this.lang.noDeposit;
      }
      this.$error("", text, res.baseDTO.transactionIsDone ? "success" : "info");
    },
    selectNet() {
      this.selected_net = this.nets[this.cryptoNetworkIndex].tokenType;
      this.txIdIsNeeded = this.nets[this.cryptoNetworkIndex].txIdIsNeeded;
      this.enable = this.nets[this.cryptoNetworkIndex].depositEnable || true;
      this.drop = false;
      if (this.enable) {
        this.getQR();
      }
    },
    async getData() {
      this.state.loading = true;
      const res = await this.$axios.get("/coins/details");
      this.coins = res.content;
      const coinData = this.coins.find((coin) => coin.name == this.relatedCoin);
      this.nets = coinData.tokenTypeDetails;
      this.wage = coinData.transferFee;
    },
    async getQR() {
      this.state.loading = true;
      const token = this.selected_net;
      let params = {
        relatedCoin: this.relatedCoin,
        tokenType: token,
      };

      console.log(params);
      const res = await this.$axios("/wallets/customer/wallet-address", {
        params,
      }).catch(() => {
        this.closeModale();
      });
      if (res) {
        this.address = res.baseDTO.address;
        this.qrCode = res.baseDTO.qrCode;
        this.tag = res.baseDTO.tag;
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
button {
  width: 100%;
}

.crypto-network {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.icon-copy {
  position: absolute;
  top: 12px;
  right: 15px;
  width: 20px;
  cursor: pointer;
}
[dir="rtl"] .icon-copy {
  right: auto;
  left: 15px;
}
.address {
  position: relative;
}
.qr-code {
  display: flex;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.qr-code > img {
  max-width: min(60%, 200px);
}

.warning {
  color: #82112b;
  font-size: clamp(12px, 1.1vw, 14px);
}
::v-deep .address input {
  padding-right: 40px;
}
[dir="rtl"] .address::v-deep input {
  padding-right: 0;
  padding-left: 40px;
}
</style>
